import { colors } from "../colors";

export const brandButton = {
  minWidth: "130px",
  height: "44px",
  borderRadius: "14px",
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  background: `linear-gradient(135deg, ${colors.orange.base}, ${colors.yellow[400]})`,
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  px: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 4px 14px rgba(251, 142, 0, 0.25)",
  transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)",
    transition: "left 0.6s ease",
  },

  "&:hover": {
    background: `linear-gradient(135deg, ${colors.orange[600]}, ${colors.orange[500]})`,
    boxShadow: "0 6px 20px rgba(251, 142, 0, 0.35)",
    transform: "translateY(-2px) scale(1.02)",
  },

  "&:hover::before": {
    left: "100%",
  },

  "&:active": {
    transform: "translateY(-1px) scale(0.99)",
  },

  "& .MuiSvgIcon-root": {
    fontSize: "18px",
  },

  "& .MuiAvatar-root": {
    width: "30px",
    height: "30px",
    border: `2px solid white`,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  },
};

export const outLinedButton = {
  minWidth: "75px",
  height: "38px",
  borderRadius: "12px",
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  border: `1px solid ${colors.orange[200]}`,
  background: "var(--fx-surface-base, #FFFFFF)",
  color: colors.orange.base,
  gap: "6px",
  px: 2.5,

  "&:hover": {
    background: colors.orange[300],
    color: "white",
    boxShadow: "none",
  },

  "&:active": {
    transform: "translateY(-1px) scale(1)",
  },

  "& .MuiSvgIcon-root": {
    fontSize: "16px",
  },
};

export const filledButton = {
  minWidth: "alignContent",
  height: "38px",
  borderRadius: "6px",
  fontSize: "13px",
  fontWeight: 500,
  textTransform: "none",
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  color: colors.orange.base,
  border: `1px solid ${colors.orange[200]}`,
  boxShadow: "none",
  transition: "background-color 0.15s ease, border-color 0.15s ease",

  "&:hover": {
    backgroundColor: colors.orange[50],
    borderColor: colors.orange[300],
    boxShadow: "none",
  },

  "&:active": {
    backgroundColor: colors.orange[100],
    borderColor: colors.orange[400],
    boxShadow: "none",
  },

  "&:focus": {
    boxShadow: "none",
  },

  "&.Mui-disabled": {
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    color: colors.gray[400],
    borderColor: colors.gray[200],
    boxShadow: "none",
  },
};

export const filledButtonSecondary = {
  minWidth: "200px",
  height: "45px",
  borderRadius: "12px",
  fontSize: "1rem",
  fontWeight: 500,
  textTransform: "none",
  px: { xs: 1, sm: 2 },
  py: { xs: 0.5, sm: 0.75 },
  backgroundColor: colors.orange.base,
  color: "#FFFFFF",
  border: "none",
  boxShadow: "none",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: colors.orange[600],
    color: "#FFFFFF",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },

  "&:active": {
    backgroundColor: colors.orange[700],
    color: "#FFFFFF",
  },

  "&.Mui-disabled, &:disabled": {
    backgroundColor: "#E0E0E0",
    color: "#9E9E9E",
    border: "none",
    boxShadow: "none",
    cursor: "not-allowed",
    pointerEvents: "auto",

    "&:hover": {
      backgroundColor: "#E0E0E0",
      color: "#9E9E9E",
      boxShadow: "none",
    },
  },
};

export const filledButtonBlue = {
  minWidth: "alignContent",
  height: "38px",
  borderRadius: "6px",
  fontSize: "13px",
  fontWeight: 500,
  textTransform: "none",
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  color: colors.blue.base,
  border: `1px solid ${colors.blue[200]}`,
  boxShadow: "none",
  transition: "background-color 0.15s ease, border-color 0.15s ease",

  "&:hover": {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
    boxShadow: "none",
  },

  "&:active": {
    backgroundColor: colors.blue[100],
    borderColor: colors.blue[400],
    boxShadow: "none",
  },

  "&:focus": {
    boxShadow: "none",
  },

  "&.Mui-disabled": {
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    color: colors.gray[400],
    borderColor: colors.gray[200],
    boxShadow: "none",
  },
};
